import { useEffect, useState } from "react";
import axios from "axios";
import { Reveal } from "@/components/Reveal";
import { ArrowUpRight, Megaphone } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export default function News() {
  const [news, setNews] = useState(null);

  useEffect(() => {
    axios.get(`${API}/news`).then((r) => setNews(r.data)).catch(() => setNews([]));
  }, []);

  if (!news || news.length === 0) return null;

  return (
    <section id="neuigkeiten" className="py-16 md:py-24 bg-[#EFECE4] border-b border-[#D8D3C5]" data-testid="news-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mb-10 md:mb-12 flex items-center gap-4">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#1A382B] text-[#F8F7F2]">
            <Megaphone size={20} strokeWidth={1.8} />
          </span>
          <div>
            <p className="eyebrow" data-testid="news-eyebrow">Aktuell · Neuigkeiten</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#1A382B]">
              Neuigkeiten aus der Anlage
            </h2>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="news-list">
          {news.map((n, i) => (
            <Reveal key={n.id} delay={i * 0.08}>
              <article
                className="group h-full flex flex-col rounded-2xl border border-[#D8D3C5] bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#5A826B] hover:shadow-[0_18px_36px_rgba(26,56,43,0.12)]"
                data-testid={`news-card-${i}`}
              >
                <p className="font-jbm text-xs tracking-wider uppercase text-[#5A826B]">{formatDate(n.created_at)}</p>
                <h3 className="mt-3 font-display text-xl sm:text-2xl font-semibold text-[#1A382B]">{n.title}</h3>
                <p className="mt-2 text-sm sm:text-base leading-relaxed text-[#47544A] line-clamp-2">{n.text}</p>
                {n.link_url && (
                  <a
                    href={n.link_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`news-link-${i}`}
                    className="mt-auto pt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#C85A32] transition-colors hover:text-[#1A382B]"
                  >
                    {n.link_label || "Mehr erfahren"}
                    <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
